import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Card,
    CardBody,
    Row,
    Col,
    CardText,
    Button,
} from "reactstrap";
import Moment from "react-moment";
import { FaMessage } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import createUserSelector from "store/users/selector";
import { BsExclamationCircle } from "react-icons/bs";
import { RxCrossCircled } from "react-icons/rx";
import axios from "axios";
import { callMessageNotification } from "store/Message/actions";
import MessageReply from "./MessageReply";
import socket from "socket/socket";
import MessageDetails from "./MessageDetails";

import "./MessageModal.css";

const RequestFootageModal = ({ messageNotifications, toggle }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const sortedNotifications = [...messageNotifications].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    );

    const handleClearAll = async (recieverId) => {
        setIsLoading(true);

        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/twilio/message-notifications-clear/${recieverId}`
            );

            if (response.status === 200) {
                dispatch(callMessageNotification(true));
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen toggle={toggle} size="lg" className="message-modal">
            <ModalHeader toggle={toggle} className="fw-semibold fs-5">
                Request Footage
            </ModalHeader>

            <ModalBody className="message-body">

                {sortedNotifications.length > 0 ? (
                    sortedNotifications.map((notification) => (
                        <NotificationCard
                            key={notification._id}
                            notification={notification}
                        />
                    ))
                ) : (
                    <NotMessageCard />
                )}

                <div className="text-end mt-3">
                    <Button
                        disabled={sortedNotifications.length === 0}
                        color="light"
                        size="sm"
                        onClick={() => handleClearAll("RequestFootage")}
                    >
                        Clear All
                    </Button>
                </div>

            </ModalBody>
        </Modal>
    );
};





/* ========================
   Notification Card
======================== */

const NotificationCard = ({ notification }) => {
    const dispatch = useDispatch();
    const userSelector = useSelector(createUserSelector);
    const { allLoginCustomer } = userSelector;

    const [showLessMessage, setShowLessMessage] = useState(false);
    const [hoveredId, setHoveredId] = useState(null);
    const [isReplyOpen, setIsReplyOpen] = useState(false);

    const userName =
        allLoginCustomer.find(
            (user) => String(user._id) === String(notification.sender)
        )?.name || "N/A";

    const handleRemoveMessage = async (messageId) => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/twilio/message-notifications-remove/${messageId}`
            );

            if (response.status === 200) {
                dispatch(callMessageNotification(true));
                socket.emit("message:delete", { messageId });
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Card
            className="notification-card mb-2"
            onMouseEnter={() => setHoveredId(notification._id)}
            onMouseLeave={() => setHoveredId(null)}
        >
            <CardBody>

                <Row className="align-items-start">

                    {/* icon */}
                    <Col xs="1">
                        <BsExclamationCircle className="text-warning mt-1" size={18} />
                    </Col>

                    {/* content */}
                    <Col xs="11">

                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-start">

                            <div>
                                <div className="fw-semibold">
                                    Request Footage from {userName}
                                </div>

                                <div className="message-text mt-1">
                                    {!showLessMessage ? (
                                        <>
                                            {notification.messageContent.substring(0, 80)}
                                            {notification.messageContent.length > 80 && (
                                                <span
                                                    className="text-primary fw-semibold ms-1 cursor"
                                                    onClick={() => setShowLessMessage(true)}
                                                >
                                                    more
                                                </span>
                                            )}
                                        </>
                                    ) : (
                                        notification.messageContent
                                    )}
                                </div>

                                {showLessMessage && (
                                    <div
                                        className="text-primary small cursor mt-1"
                                        onClick={() => setShowLessMessage(false)}
                                    >
                                        Show Less
                                    </div>
                                )}
                            </div>

                            <small className="text-muted">
                                <Moment fromNow>{notification.timestamp}</Moment>
                            </small>

                        </div>


                        {/* bottom actions */}
                        <Row className="mt-2 align-items-center">

                            <Col>
                                <MessageReply
                                    notification={notification}
                                    allLoginCustomer={allLoginCustomer}
                                    isReplyOpen={isReplyOpen}
                                    setIsReplyOpen={setIsReplyOpen}
                                />
                            </Col>

                            <Col className="text-end">

                                {hoveredId === notification._id && (
                                    <RxCrossCircled
                                        className="text-danger cursor"
                                        size={18}
                                        onClick={() =>
                                            handleRemoveMessage(notification._id)
                                        }
                                    />
                                )}

                                <MessageDetails
                                    notification={notification}
                                    allLoginCustomer={allLoginCustomer}
                                    isReplyOpen={isReplyOpen}
                                    setIsReplyOpen={setIsReplyOpen}
                                />

                            </Col>

                        </Row>

                    </Col>

                </Row>

            </CardBody>
        </Card>
    );
};





/* ========================
   Empty State
======================== */

const NotMessageCard = () => (
    <CardBody className="text-center py-5 empty-state">
        <FaMessage size={40} />
        <CardText className="mt-3 fw-semibold">
            No Request Footage Messages
        </CardText>
    </CardBody>
);

export default RequestFootageModal;
